import { buildGlobalAction, buildInlineComputedView } from "./../builder.js";
class OnboardingNamespace {
  constructor(clientOrParent) {
    this.clientOrParent = clientOrParent;
    /** Executes the checkOnBoardingPrerequisites global action. */
    this.checkOnBoardingPrerequisites = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "checkOnBoardingPrerequisites",
      operationName: "checkOnBoardingPrerequisites",
      operationReturnType: "OnboardingCheckOnBoardingPrerequisites",
      namespace: "onboarding",
      variables: {}
    });
    /** Executes an inline computed view. */
    this.view = buildInlineComputedView(this, {
      type: "computedView",
      operationName: "gellyView",
      functionName: "view",
      gqlFieldName: "gellyView",
      namespace: "onboarding",
      variables: {
        query: { type: "String", required: true },
        args: { type: "JSONObject" }
      }
    });
    this.connection = this.clientOrParent.connection;
  }
}
export {
  OnboardingNamespace
};
//# sourceMappingURL=onboarding.js.map
